import { render, staticRenderFns } from "./AddressTranslation.vue?vue&type=template&id=1ca79eec&scoped=true&"
import script from "./AddressTranslation.vue?vue&type=script&lang=js&"
export * from "./AddressTranslation.vue?vue&type=script&lang=js&"
import style0 from "./AddressTranslation.vue?vue&type=style&index=0&id=1ca79eec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca79eec",
  null
  
)

export default component.exports